<!--站点管理-->
<template>
    <div>
        <top-bar
            :height="'48vh'"
            title="站点管理"
            addTitle="添加站点"
            @refresh="getAreaCode"
            @add="add"
            :loading="loading"
            :isShowRefresh="true"
            @search="search"
        />
        <v-container fluid class="mt-n6">
            <v-card outlined :color="theme.elementBgColor">
                <!-- 地区选择 -->
                <v-tabs
                    v-model="cityTab"
                    :background-color="theme.navigationDrawerBgColor"
                    center-active
                    dark
                >
                    <v-tabs-slider
                        style="height:0.5vh;margin-top:-1px"
                        color="white"
                    ></v-tabs-slider>
                    <v-tab
                        v-for="(provinces, index1) in handelTabs"
                        :key="index1"
                        @change="handleChange(provinces)"
                    >
                        {{ provinces.label }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="cityTab">
                    <v-tab-item v-for="(provinces, index2) in handelTabs" :key="index2">
                        <!-- 数据表 -->
                        <v-data-table
                            :headers="headers"
                            :items="provinces.children"
                            :loading="loading"
                            loading-text="数据加载中..."
                            disable-sort
                            no-data-text="暂未查询到数据，请尝试刷新"
                            :server-items-length="totalCount"
                            :options.sync="options"
                            :footer-props="footerProps"
                            :dark="theme.tableDark"
                        >
                            <template v-slot:item.name="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.name"
                                    placement="top"
                                >
                                    <div class="textOver" style="width: 10rem">
                                        <el-link
                                            type="primary"
                                            icon="el-icon-view el-icon--right"
                                            class="ml-3 "
                                            @click="editor(item)"
                                        >
                                            {{ item.name }}
                                        </el-link>
                                    </div>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.price="{ item }">
                                <div style="display:flex;flex-direction:row; align-items: center;">
                                    <v-menu open-on-hover top offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                elevation="0"
                                                class="textOver"
                                                style="width: 5em"
                                            >
                                                <div
                                                    v-for="(money, index) in item.price"
                                                    :key="index"
                                                    v-if="index === 0"
                                                >
                                                    {{
                                                        addNum(
                                                            dealPrice(money.elec_price),
                                                            dealPrice(money.sevice_price)
                                                        )
                                                    }}
                                                </div>
                                            </v-btn>
                                        </template>
                                        <div style="width:40vw">
                                            <price-table
                                                :applyPrice="item.price"
                                                :disabled="(disabled = true)"
                                            />
                                        </div>
                                    </v-menu>
                                    <div
                                        style="
                                            background-color: #409eff;
                                            border-radius:50%;
                                            color: #ffffff;
                                            width: 1.6rem;
                                            height:1.6rem;
                                            font-size: 1rem;
                                            display:flex;
                                            justify-content: center;
                                            align-items: center;"
                                        class="ml-1"
                                        @click="ApplyPrice(item)"
                                    >
                                        <i class="el-icon-edit"></i>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:item.charging="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.chargingNums"
                                    placement="top"
                                >
                                    <el-badge
                                        type="primary"
                                        :max="50"
                                        :value="item.chargingNums"
                                        class="item"
                                    >
                                        <v-img
                                            style="cursor:pointer"
                                            height="30px"
                                            contain
                                            src="@/assets/car.svg"
                                            @click="showDevices(item, 2)"
                                            width="30px"
                                            class="mt-1"
                                        ></v-img>
                                    </el-badge>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.free="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.freeNums"
                                    placement="top"
                                >
                                    <el-badge :value="item.freeNums" type="success" class="item">
                                        <i
                                            @click="showDevices(item, 1)"
                                            class="iconfont icon-chongdianqiang1"
                                            style="font-size:2.1em;color:#95de64"
                                        ></i>
                                    </el-badge>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.offline="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.offlineNums"
                                    placement="top"
                                >
                                    <el-badge type="warning" :value="item.offlineNums" class="item">
                                        <i
                                            @click="showDevices(item, 0)"
                                            class="iconfont icon-chongdianqiang1"
                                            style="font-size:2.1em;color:#d9d9d9"
                                        ></i>
                                    </el-badge>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.fault="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.faultNums"
                                    placement="top"
                                >
                                    <el-badge :value="item.faultNums" class="item">
                                        <i
                                            @click="showDevices(item, 254)"
                                            class="iconfont icon-chongdianqiang1"
                                            style="font-size:2.1em;color:#ff4d4f"
                                        ></i>
                                    </el-badge>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.info="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.info ? item.info : ''"
                                    placement="top"
                                >
                                    <div class="textOver" style="width: 4em">
                                        {{ item.info }}
                                    </div>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.address="{ item }">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="item.address ? item.address : ''"
                                    placement="top"
                                >
                                    <div class="textOver">
                                        {{ item.address }}
                                    </div>
                                </el-tooltip>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <el-dropdown @command="modifyStatus" trigger="click">
                                    <el-link
                                        icon="el-icon-edit"
                                        type="primary"
                                        class="textOver"
                                        style="width: 100%"
                                        @click="clickStatus(item)"
                                    >
                                        {{ siteStatus(item.status) }}
                                    </el-link>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            v-for="(item, index) in status"
                                            :key="index"
                                            :command="item.id"
                                            :disabled="item.disabled"
                                        >
                                            {{ item.text }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <el-button type="text" @click="deleteItem(item)">
                                    <v-icon class="ml-3" color="red">
                                        mdi-delete
                                    </v-icon>
                                </el-button>
                            </template>
                            <!-- <template v-slot:item.cec="{ item }">
                                <div v-if="item.cec_id" style="width:5em">
                                    <el-tag size="mini">
                                        {{ cecText(item.cec_id) }}
                                    </el-tag>
                                </div>
                            </template> -->
							<template v-slot:item.platform_id="{ item }">
							    <div v-if="role == 0" style="width:5em">
							        <el-tag size="mini">
							            {{ platformText(item.platform_id) }}
							        </el-tag>
							    </div>
							</template>
                            <template v-slot:item.qrCode="{ item }">
                                <el-button
                                    type="primary"
                                    icon="el-icon-download"
                                    circle
                                    size="mini"
                                    @click="packageImages(item.id, item.name)"
                                ></el-button>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-container>
        <!-- 编辑弹出框 -->
        <v-dialog
            scrollable
            v-model="isEdit"
            :persistent="persistent"
            width="60em"
            overlay-color="#262626"
        >
            <site-form
                @noEditor="noEditor"
                @refresh="getAreaCode"
                :isAdd="isAdd"
                :editSite="editSite"
                :allArea="allArea"
                v-if="isEditSite"
            />
        </v-dialog>
        <!-- 价格弹出框 -->
        <v-dialog
            scrollable
            v-model="isApply"
            :persistent="persistent"
            width="53em"
            overlay-color="#262626"
        >
            <apply-price
                @noApply="noApply"
                :applyPrice="applyPrice"
                :siteId="siteId"
                @refresh="getSite"
                :area="handelTabs[cityTab]"
            />
        </v-dialog>
        <!-- 下载二维码 -->
        <v-dialog
            scrollable
            v-model="isDownload"
            :persistent="persistent"
            width="20rem"
            v-if="updateImage"
            overlay-color="#262626"
        >
            <packge-images-qv :siteId="downloadId" :siteName="downloadName" @cancal="noDownload" />
        </v-dialog>
       <!-- <el-button type="primary" @click="getAllGun()">获取当前区域所有充电枪数据</el-button>
        <el-button type="primary" @click="getAllPile()">获取当前区域所有充电桩数据</el-button> -->
        <el-button type="primary" @click="getAllGun()">获取{{area}}所有站点数据</el-button>
        <download-excel
            class = "export-excel-wrapper"
            :data = "json_data"
            :fields = "json_fields"
            :title='area + "所有站点数据"'
            :name = "area + '站点信息.xls'">
            <el-button type="primary">导出{{area}}所有站点数据为EXCEL</el-button>
        </download-excel>
    </div>
</template>

<script>
import util from "@/util";
import SiteForm from "@/components/Form/SiteForm";
import ApplyPrice from "@/components/ApplyPrice";
import PriceTable from "@/components/Table/PriceTable";
import TopBar from "@/components/TopBar";
import PackgeImagesQs from "@/components/PackgeImagesQs";
import PackgeImagesQv from "@/components/PackgeImagesQv";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "StationManageMent",
    data() {
        return {
            json_fields: {
                "站点ID": "id",
                "所属行政区": "area",
                "站点名称": "name",
                "是否充电站": "isSite",
                "信息": "info",
                "站点地址": "address",
                "纬度": "lat",
                "经度": "lng",
                "额定功率总和": "allPower",
                "充电桩数量": "pileNums",
                "充电枪数量": "gunNums",
                "状态": "status_text",
                "运营商ID": "operator_id",
                "价格": "price",
                "照片": "pic"
            },
            json_data:[],    //导出表格数据
            json_meta: [
              [
                {
                  " key ": " charset ",
                  " value ": " utf- 8 "
                }
              ]
            ],
            loading: false,
            allGun: [],
            allPile: [],
            cityTab: 0,
            handelTabs: [
                // {
                //     label: '江西省',
                //     children: [
                //         {
                //             id: 2,
                //             name: '站点2', //站点名称
                //             area_code: '江西省', //站点位于的省份
                //             city_code: '南昌市', //站点位于的市
                //             area: '西湖区', //站点位于的区
                //             tag: [0, 1, 2], //服务标签
                //             info: '这是站点2', //站点简介
                //             lng: 115.904539, //经度
                //             lat: 28.686507, //纬度
                //             operatorID: null, //运营商ID
                //             address: '', //地址
                //             price: [
                //                 { time: 4, elec_price: 70, sevice_price: 30 },
                //                 { time: 24, elec_price: 70, sevice_price: 30 },
                //             ], //价格
                //             pic: [], //站点图片,
                //         },
                //     ],
                // },
            ],
            headers: [
                { text: "名称", value: "name" },
                { text: "信息", value: "info" },
                { text: "地址", value: "address" },
                { text: "价格(元)", value: "price" },
                { text: "状态", value: "status" },
                // { text: "互联互通", value: "cec" },
				{ text: "平台", value: "platform_id" },
                { text: "充电中", value: "charging" },
                { text: "空闲", value: "free" },
                { text: "离线", value: "offline" },
                { text: "故障", value: "fault" },
                { text: "二维码", value: "qrCode" },
                { text: "", value: "action" },
            ],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
            siteData: [],
            isEdit: false, //是否打开编辑弹出框
            isAdd: false, //是添加站点
            persistent: true, //点击遮罩层是否突出编辑
            isEditSite: true,
            isApply: false, //是否修改价格
            applyPrice: [], //向编辑价格组件传递价格的数据
            siteId: null, //向编辑价格组件传递站点的id
            editSite: {}, //向编辑站点组件传递的数据
            area: "", //当前选中的区域
            status: [
                //状态
                { id: "0", text: "未知", disabled: false },
                { id: "1", text: "建设中", disabled: false },
                { id: "5", text: "关闭下线", disabled: false },
                { id: "6", text: "维护中", disabled: false },
				{ id: "7", text: "内部场站", disabled: false },
                { id: "50", text: "正常", disabled: false },
            ],
            clickSiteId: null, //点击数据表中的状态选择的站点id
            isSearch: false, //是否搜索
            isDownload: false, //是否下载二维码图片
            downloadId: null, //需要下载二维码图片的站点id
            downloadName: null, //需要下载二维码图片的站点名称
            updateImage: true, //销毁下载图片的组件
            nums: 0,
        };
    },
    components: {
        SiteForm,
        ApplyPrice,
        PriceTable,
        TopBar,
        PackgeImagesQs,
        PackgeImagesQv,
    },
    watch: {
        editSite() {
            this.isEditSite = false;
            this.$nextTick(() => {
                this.isEditSite = true;
            });
        },
        downloadId() {
            this.updateImage = false;
            this.$nextTick(() => {
                this.updateImage = true;
            });
        },
        options: {
            handler() {
                if (!this.isSearch) {
                    this.getSite(this.area);
                }
            },
            deep: true,
        },
        area: {
            handler(val) {
                if (!this.isSearch) {
                    this.getSite(val);
                }
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["allArea", 
					"siteInfo", 
					"connectorInfo", 
					"contactInfo", 
					"theme",
					"siteList",
					"equipmentInfo",
					"platformList",
					"role"]),
    },
    mounted() {
        this.IEVersion();
    },
    methods: {
        async get() {
            let postData = {
                area_code: this.area,
                from: 0,
                limit: 100000,
            };
            await store.dispatch("getSite", postData);
            let info = [];
            let siteinfos = this.siteInfo;
            for(let i = 0;i<siteinfos.length;i++) {
                siteinfos[i].price = JSON.stringify(siteinfos[i].price)
                siteinfos[i].pic = JSON.stringify(siteinfos[i].pic)
                siteinfos[i].area = "南昌市";
                siteinfos[i].isSite = "是";
                siteinfos[i].gunNums = 0;
                siteinfos[i].pileNums = 0;
                siteinfos[i].allPower = 0;
                for(let j = 0;j<this.status.length;j++) {
                    if(siteinfos[i].status == Number(this.status[j].id)) {
                        siteinfos[i].status_text = this.status[j].text
                    }
                }
                // if(siteinfos[i].status == 50) {
                    info.push(siteinfos[i])
                // }
            }
            for(let i = 0;i<info.length;i++) {
                for(let j = 0;j<this.allGun.length;j++) {
                    if(info[i].id == this.allGun[j].station_id) {
                        info[i].gunNums += 1
                    }
                }
            }
            for(let i = 0;i<info.length;i++) {
                for(let j = 0;j<this.allPile.length;j++) {
                    if(info[i].id == this.allPile[j].station_id) {
                        info[i].pileNums += 1
                        info[i].allPower += this.allPile[j].power
                    }
                }
                
            }
            console.log(info)
            this.json_data = info;
        },
        //获取所有充电桩数据
        async getAllPile() {
            const loading = this.$loading({
                lock: true,
                text: '获取'+this.area+'所有充电桩数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            console.log(site)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                if(site[i].label === this.area) {
                    for(let j = 0;j<site[i].children.length;j++) {
                        // if(site[i].children[j].status == 50) {
                            allsite.push({
                                station_id: site[i].children[j].id,
                                station_name: site[i].children[j].value
                            })
                        // }
                    }
                }
            }
            let promiseArr = [];
            let postDataArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                    from: 0,
                    limit: 10000,
                };
                await store.dispatch("getEquipment", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.equipmentInfo)
                    // for(let j = 0;j<data.length;j++) {
                    //     data[j].station_id = allsite[i].station_id
                    // }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            for(let n = 0; n<allsite.length;n++) {
                                if(allsite[n].station_id == result[i].value[j].station_id) {
                                    result[i].value[j].station_name = allsite[n].station_name
                                }
                            }
                            info.push(result[i].value[j])
                        }
                    }
                    for(let a = 0;a<info.length;a++) {
                        info[a].nums = 0;
                         if(info[a].type == 1) {
                             info[a].type_text = "直流设备"
                         }else if(info[a].type == 2) {
                             info[a].type_text = "交流设备"
                         }else if(info[a].type == 3) {
                             info[a].type_text = "交直流一体设备"
                         }else if(info[a].type == 4) {
                             info[a].type_text = "无线设备"
                         }
                         else if(info[a].type == 5) {
                             info[a].type_text = "其他"
                         }
                    }
                    console.log(this.allGun)
                    for(let i = 0;i<info.length;i++) {
                        for(let j = 0;j<this.allGun.length;j++) {
                            if(info[i].id == this.allGun[j].equipment_id && info[i].station_id == this.allGun[j].station_id) {
                                info[i].nums += 1
                            }
                        }
                    }
                    console.log(info)
                    this.allPile = info;
                    loading.close();
                    // util.ShowTip("总共获取到"+info.length+"条数据", 1);
                    this.get()
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        //获取所有充电枪数据
        async getAllGun() {
            const loading = this.$loading({
                lock: true,
                text: '获取'+this.area+'所有充电枪数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                if(site[i].label === this.area) {
                    for(let j = 0;j<site[i].children.length;j++) {
                        // if(site[i].children[j].status == 50) {
                            allsite.push({
                                station_id: site[i].children[j].id,
                                station_name: site[i].children[j].value
                            })
                        // }
                    }
                }
            }
            console.log(allsite)
            let promiseArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                };
                await store.dispatch("getConnector", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.connectorInfo)
                    for(let j = 0;j<data.length;j++) {
                        data[j].station_id = allsite[i].station_id
                    }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            info.push(result[i].value[j])
                        }
                    }
                    for(let a = 0;a<info.length;a++) {
                        if(info[a].type == 1) {
                            info[a].type_text = "家用插座"
                        }else if(info[a].type == 2) {
                            info[a].type_text = "交流接口插座"
                        }else if(info[a].type == 3) {
                            info[a].type_text = "交流接口插头"
                        }else if(info[a].type == 4) {
                            info[a].type_text = "直流接口枪头"
                        }
                        else if(info[a].type == 5) {
                            info[a].type_text = "无线充电座"
                        }
                        else if(info[a].type == 6) {
                            info[a].type_text = "其他"
                        }
                    }
                    // console.log(info)
                    this.allGun = info;
                    loading.close();
                    // util.ShowTip("总共获取到"+info.length+"条数据", 1);
                    this.getAllPile();
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        // 判断IE浏览器版本
        IEVersion() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6; //IE版本<=7
                }
                console.log("IE" + fIEVersion);
            } else if (isEdge) {
                console.log("edge");
                return "edge"; //edge
            } else if (isIE11) {
                console.log("IE11");
                return 11; //IE11
            } else {
                console.log("不是ie浏览器");
                return -1; //不是ie浏览器
            }
        },
        packageImages(id, name) {
            this.isDownload = true;
            this.downloadId = id;
            this.downloadName = name;
        },
        noDownload() {
            this.isDownload = false;
            this.downloadId = null;
            this.downloadName = null;
        },
        /*获取所有区域*/
        async getAreaCode() {
            this.loading = true;
            this.isSearch = false;
            await store.dispatch("getArea", {});
            try {
                this.handelTabs = [];
                for (let i = 0; i < this.allArea.length; i++) {
                    this.handelTabs[i] = {
                        label: null,
                        children: [],
                    };
                    this.handelTabs[i].label = this.allArea[i];
                }
                if (!this.area) {
                    this.area = this.handelTabs[0].label;
                } else {
                    this.getSite(this.area);
                }
				this.getPlatformList()
            } catch (e) {}
        },
        /*获取当前区域站点相关信息*/
        async getSite(area) {
            this.loading = true;
            const { page, itemsPerPage } = this.options;
            let postData = {
                area_code: area,
                from: (page - 1) * itemsPerPage,
                limit: itemsPerPage,
            };
            await store.dispatch("getSite", postData);
            let stations = this.JsonData(this.siteInfo);
            let promiseArr = [];
            for (let i = 0; i < stations.length; i++) {
                let postData2 = {
                    station_id: stations[i].id,
                };
                await store.dispatch("getConnector", postData2);
                let promise = new Promise((resolve, reject) => {
                    resolve(this.connectorInfo);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    for (let i = 0; i < stations.length; i++) {
                        stations[i].chargingNums = 0;
                        stations[i].freeNums = 0;
                        stations[i].offlineNums = 0;
                        stations[i].faultNums = 0;
                        for (let j = 0; j < result[i].value.length; j++) {
                            if (result[i].status === "fulfilled") {
                                if (result[i].value[j].status === 2) {
                                    stations[i].chargingNums += 1;
                                } else if (result[i].value[j].status === 1) {
                                    stations[i].freeNums += 1;
                                } else if (result[i].value[j].status === 0) {
                                    stations[i].offlineNums += 1;
                                } else if (
                                    result[i].value[j].status === 255 ||
                                    result[i][j].status === 254
                                ) {
                                    stations[i].faultNums += 1;
                                }
                            } else {
                                console.log(result[i]);
                            }
                        }
                    }
                    for (let i = 0; i < stations.length; i++) {
                        stations[i].chargingNums = stations[i].chargingNums.toString();
                        stations[i].freeNums = stations[i].freeNums.toString();
                        stations[i].offlineNums = stations[i].offlineNums.toString();
                        stations[i].faultNums = stations[i].faultNums.toString();
                    }
                    this.loading = false;
                    let index = null;
                    this.handelTabs.forEach((val, i) => {
                        if (area === val.label) {
                            index = i;
                        }
                    });
                    this.handelTabs[index].children = stations.reverse();
                    console.log(this.handelTabs);
                    let nums = 0;
                    for (let i = 0; i < this.handelTabs.length; i++) {
                        for (let j = 0; j < this.handelTabs[i].children.length; j++) {
                            let num =
                                Number(this.handelTabs[i].children[j].chargingNums) +
                                Number(this.handelTabs[i].children[j].freeNums) +
                                Number(this.handelTabs[i].children[j].offlineNums) +
                                Number(this.handelTabs[i].children[j].faultNums);
                            nums += num;
                        }
                    }
                    this.nums += nums;
                    console.log(this.nums);
                })
                .catch(error => {
                    console.log(error);
                    util.ShowTip(error, 2);
                });
        },
        /*获取平台*/
		async getPlatformList() {
            let postData = {};
            await store.dispatch("getplatformList", postData);
        },
		/*点击导航头部*/
        handleChange(province) {
            let data = this.JsonData(province);
            this.options.page = 1;
            this.area = data.label;
        },
        /*在输入框中输入搜索站点*/
        async search(reg) {
            console.log(reg)
            let regStr = reg.toString().substring(1, reg.toString().length - 2);
            let status;
            this.status.forEach((val, index) => {
                if (val.text == regStr) {
                    status = Number(val.id);
                }
            });
            let reg2;
            if (status) {
                reg2 = eval("/" + status + "/g");
            }
            this.isSearch = false;
            this.loading = true;
            await store.dispatch("getSite", { from: 0, limit: 10000 });
            let dataArr = [];
            for (let i = 0; i < this.siteInfo.length; i++) {
                if (
                    reg.test(this.siteInfo[i].address) ||
                    reg.test(this.siteInfo[i].name) ||
                    reg.test(this.siteInfo[i].id) ||
                    reg.test(this.siteInfo[i].cec_station_id) ||
                    reg.test(this.siteInfo[i].city_code)
                ) {
                    dataArr.push(this.siteInfo[i]);
                }
                if (reg2 && reg2.test(this.siteInfo[i].status)) {
                    dataArr.push(this.siteInfo[i]);
                }
            }
            if (dataArr.length == 0) {
                util.ShowTip("未查找到相关数据", 2);
                await this.getAreaCode();
                return;
            }
            let promiseArr = [];
            for (let i = 0; i < dataArr.length; i++) {
                let postData2 = {
                    station_id: dataArr[i].id,
                };
                await store.dispatch("getConnector", postData2);
                let promise = new Promise((resolve, reject) => {
                    resolve(this.connectorInfo);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    for (let i = 0; i < dataArr.length; i++) {
                        dataArr[i].chargingNums = 0;
                        dataArr[i].freeNums = 0;
                        dataArr[i].offlineNums = 0;
                        dataArr[i].faultNums = 0;
                        for (let j = 0; j < result[i].value.length; j++) {
                            if (result[i].status === "fulfilled") {
                                if (result[i].value[j].status === 2) {
                                    dataArr[i].chargingNums += 1;
                                } else if (result[i].value[j].status === 1) {
                                    dataArr[i].freeNums += 1;
                                } else if (result[i].value[j].status === 0) {
                                    dataArr[i].offlineNums += 1;
                                } else if (
                                    result[i].value[j].status === 255 ||
                                    result[i][j].status === 254
                                ) {
                                    dataArr[i].faultNums += 1;
                                }
                            } else {
                                console.log(result[i]);
                            }
                        }
                    }
                    for (let i = 0; i < dataArr.length; i++) {
                        dataArr[i].chargingNums = dataArr[i].chargingNums.toString();
                        dataArr[i].freeNums = dataArr[i].freeNums.toString();
                        dataArr[i].offlineNums = dataArr[i].offlineNums.toString();
                        dataArr[i].faultNums = dataArr[i].faultNums.toString();
                    }
                    console.log(dataArr);
                    let areaArr = [];
                    for (let j = 0; j < dataArr.length; j++) {
                        areaArr.push(dataArr[j].area_code);
                    }
                    areaArr = Array.from(new Set(areaArr));
                    let handelTabs = [];
                    for (let j2 = 0; j2 < dataArr.length; j2++) {
                        for (let j3 = 0; j3 < areaArr.length; j3++) {
                            handelTabs[j3] = {
                                label: areaArr[j3],
                                children: [],
                            };
                        }
                    }
                    for (let j4 = 0; j4 < dataArr.length; j4++) {
                        for (let j5 = 0; j5 < handelTabs.length; j5++) {
                            if (handelTabs[j5].label == dataArr[j4].area_code) {
                                handelTabs[j5].children.push(dataArr[j4]);
                            }
                        }
                    }
                    util.ShowTip("查询到" + dataArr.length + "条数据", 1);
                    this.isSearch = true;
                    this.loading = false;
                    this.handelTabs = handelTabs;
                })
                .catch(error => {
                    console.log(error);
                    util.ShowTip(error, 2);
                });
        },
        /*修改价格*/
        ApplyPrice(item) {
            this.isApply = true;
            let data = this.JsonData(item);
            this.applyPrice = data.price;
            this.siteId = data.id;
        },
        /*添加新站点*/
        add() {
            this.persistent = true;
            this.isEdit = true;
            this.isAdd = true;
            this.editSite = {
                price: [
                    {
                        time: 24,
                        elec_price: 70,
                        sevice_price: 30,
                    },
                ],
                pic: [],
            };
        },
        /*编辑站点*/
        editor(item) {
            this.persistent = false;
            this.isEdit = true;
            this.isAdd = false;
            this.editSite = this.JsonData(item);
        },
        /*取消编辑*/
        noEditor() {
            this.isEdit = false;
        },
        /*取消应用金额到其他站点*/
        noApply() {
            this.isApply = false;
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        dealPrice(price) {
            if (String(price).indexOf(".")) {
                let y = String(price).indexOf(".") + 1; //获取小数点的位置
                let count = String(price).length - y; //获取小数点后的个数
                let data = price * count * 10;
                return data / (count * 1000);
            } else {
                return price / 100;
            }
        },
        /*删除站点*/
        deleteItem(station) {
            let data = this.JsonData(station);
            const h = this.$createElement;
            this.$confirm("此操作将删除" + data.name + "站点, 是否继续?", "提示", {
                title: "提示",
                message: h("p", null, [
                    h("span", null, "此操作将删除  "),
                    h("i", { style: "color: red" }, data.name),
                    h("div", null, "  请谨慎选择!!!"),
                ]),
                showCancelButton: true,
                center: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                })
                .catch(() => {});
        },
        /*点击数据表上的状态*/
        clickStatus(item) {
            if (this.clickSiteId) {
                this.clickSiteId = null;
            }
            let index = String(item.status);
            for (let i = 0; i < this.status.length; i++) {
                if (index === this.status[i].id) {
                    this.status[i].disabled = true;
                } else this.status[i].disabled = false;
            }
            this.clickSiteId = item.id;
        },
        /*修改站点状态*/
        async modifyStatus(status) {
            let params = {
                page: this,
                postData: {
                    stationInfo: {
                        id: this.clickSiteId,
                        status: Number(status),
                    },
                },
                callback: () => {
                    this.getAreaCode();
                },
            };
            await store.dispatch("updateStation", params);
        },
        /*显示站点设备页面*/
        showDevices(item, status) {
            this.$router.push({
                name: "ChargingGun",
                params: { status: status },
            });
            store.commit("SET_ISJUMP", true);
            store.commit("SET_GUN_SITE_ID", item.id);
        },
        /*站点状态*/
        siteStatus(num) {
            let value = "";
            this.status.forEach((val, index) => {
                if (val.id == Number(num)) {
                    value = val.text;
                }
            });
            return value;
        },
        cecText(cec_id) {
            if (this.contactInfo.length === 0) {
                store.dispatch("getConnact", {});
            }
            let text = "";
            if (!cec_id) {
                return;
            }
            for (let i = 0; i < this.contactInfo.length; i++) {
                if (cec_id === this.contactInfo[i].id) {
                    text = this.contactInfo[i].name;
                }
            }
            return text;
        },
		platformText(platformId) {
			let text = "";
			for (let i = 0; i < this.platformList.length; i++) {
			    if (platformId === this.platformList[i].id) {
			        text = this.platformList[i].platform_name;
			    }
			}
			return text;
		},
        /*价格相加*/
        addNum(elec, sevice) {
            var r1, r2, m;
            try {
                r1 = elec.toString().split(".")[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = sevice.toString().split(".")[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            let a = Math.round(elec * m + sevice * m) / m;
            return a;
        },
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path === "devices/gun") {
                vm.getAreaCode();
            }
        });
    },
};
</script>
<style scoped>
.textOver {
    width: 9em;
    font-size: 1em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
</style>
